import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { getStageElementsByTypes, validateSearchResults } from '../../../functions'

import SelectForm from '../select-form'

class TableCell extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showSelectForm: false,
      focusKey: undefined
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { item, cellIndex } = this.props
    const { focusKey } = this.state

    if (item.title !== prevProps.item.title) this.props.changeFocus({preventDefault: function() {}, key: focusKey || 'Tab'}, {cell: cellIndex+1})
  }

  clearSearchResults() {
    this.props.getSearchResults([])
  }

  render() {
    const { view, channel, item, cellIndex, stageElements, options, categories } = this.props
    const { showSelectForm } = this.state

    return (
      <div className="table-cell" id={`ch${channel}-eq${cellIndex+1}`}
        onClick={() => this.setState({showSelectForm: true})}
        style={{minWidth: `${100/this.props.paging.size}%`, maxWidth: `${100/this.props.paging.size}%`}}>
        {
          showSelectForm && view.editable
          ? <SelectForm
              group={this.props.group}
              item={item}
              position={cellIndex}
              placeholder={`Enter ${item.class === 'instrument' ? "instrument" : item.type.title.toLowerCase()}`}
              promptTextCreator="Add"
              typeSelectorText="Specify it's category"
              itemGroups={this.props.itemGroups}
              itemGroupingText="We suggest grouping drum elements into"
              setFocus={true}
              setFocusKey={(e) => this.setState({focusKey: e.key})}
              changeFocus={(e) => this.props.changeFocus(e, {cell: cellIndex+1})}
              removeFocus={() => this.setState({showSelectForm: false}, () => this.clearSearchResults())}
              createRiderItem={this.props.createRiderItem}
              editRiderItem={this.props.editRiderItem}
              deleteRiderItem={this.props.deleteRiderItem}
              options={
                item.class === 'instrument'
                ? getStageElementsByTypes(['instrument'], stageElements)
                : getStageElementsByTypes([item.type.slug], stageElements)
              }
              categories={
                item.class === 'instrument'
                ? getStageElementsByTypes(['children'], stageElements.groups && stageElements.groups.instrument)
                : stageElements.isFetching !== true ? [] : undefined
              }
              createStageElement={this.props.createStageElement}
              searchResults={validateSearchResults(stageElements)}
              getSearchResults={this.props.getSearchResults} />
          : <div className="title" data-value={item.title}>{item.title}</div>
        }
      </div>
    )
  }
}

TableCell.propTypes = {
  view: PropTypes.object,
  channel: PropTypes.number,
  item: PropTypes.object,
  cellIndex: PropTypes.number,
  paging: PropTypes.object,
  itemGroups: PropTypes.array,
  changeFocus: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  options: PropTypes.array,
  categories: PropTypes.array,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

TableCell.defaultProps = {
  view: {},
  channel: undefined,
  item: {},
  cellIndex: undefined,
  paging: {},
  itemGroups: [],
  changeFocus: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  options: undefined,
  categories: undefined,
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default TableCell



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-table/table-cell.js